{
  "version": 1,
  "asset_id": "2a68e7a3-058a-4052-8658-cdbbfdb01433",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/2a68e7a3-058a-4052-8658-cdbbfdb01433/stamped-brown-patio.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/2a68e7a3-058a-4052-8658-cdbbfdb01433/stamped-brown-patio.webp",
  "original_filename": "stamped-brown-patio.webp",
  "size": 93602,
  "content_type": "image/webp",
  "created_at": "2026-08-16T22:26:32Z"
}
